import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const YOUTUBE_URL_PATTERN = /https?:\/\/(.+\.)?youtube\.com.*(\?v=([^&]+)).*$/;

const DEFAULT_WIDTH = '400px';
const DEFAULT_HEIGHT = '300px';

const stripPlayerEmbeddedFlag = (url: string): string =>
	url.includes('feature=player_embedded&') ? url.replace('feature=player_embedded&', '') : url;

export const matchYoutube: ProviderMatcher = (url, params) => {
	const sanitised = stripPlayerEmbeddedFlag(url);
	const match = YOUTUBE_URL_PATTERN.exec(sanitised);
	if (!match) {
		return null;
	}
	const videoId = match[3];
	return {
		kind: 'youtube-iframe',
		provider: 'YouTube',
		embedUrl: `//www.youtube.com/embed/${videoId}?wmode=opaque`,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
